// extracted by mini-css-extract-plugin
export default {"card":"Card_card__fzgN8","hover":"Card_hover__k5aJW"};